// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bewertung-auswertung-screen {
  position: relative;
  /*TEXT FONT*/
  font-family: Inter;
  font-style: normal;
}

/* SIDE SELECTOR START*/

.selector-container {
  position: relative;
  display: flex;
  flex-direction: row;
  top: 35px;
  height: fit-content;
  margin-right: 42px;
  margin-left: 42px;
  border-radius: 10px;
  background: var(--searchbar-background);

  /*Text Font*/
  text-align: center;
  /* Inter / 24 sp • H5 */
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.selector-item-selected {
  display: flex;
  align-items: center;
  /* Center vertically */
  justify-content: center;
  /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  background: var(--white-base);
  width: 100%;
  text-align: center;
  /* Center text within the flex container */
}

.selector-item-not-selected {
  display: flex;
  align-items: center;
  /* Center vertically */
  justify-content: center;
  /* Center horizontally */
  border-radius: 10px;
  cursor: pointer;
  margin: 5px;
  width: 100%;
  text-align: center;
  /* Center text within the flex container */
}

.selector-divider {
  width: 1.48px;
  height: 50.8px;
  background-color: var(--gray-20);
  margin: 10px;
}

/* SIDE SELECTOR END */

/* MAIN CONTENT START*/
.ga-singleContent-container {
  position: relative;
  margin-top: 80px;
  margin-left: var(--content-space);
  margin-right: var(--content-space);
  /* Add vertical gap between children */
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 30px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--white-base);

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.ga-radar-parent-container{
  max-height: 1000px;
}

/* MAIN CONTENT END*/

.singleContent-container-selector {
  position: relative;
  max-height: 1000px;
  margin-right: 0px;
  margin-left: auto;
  width: fit-content;
}


/* Style for the bar chart container */
.singleContent-row-container {
  display: flex;
  flex-direction: column;
  /* Stack the children vertically */
  align-items: stretch;
  /* Stretch children to match the container's width */
  justify-content: flex-start;
  position: relative;
  display: flex;
  /* Align children in a row */
  flex-direction: row;
  justify-content: space-between;
  /* Distribute space between children */
  gap: 30px;
  border-radius: 10px;
  background: var(--white-base);

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 18px */
}

.singleContent-column-container {
  display: flex;
  flex-direction: column;
  /* Stack the children vertically */
  align-items: stretch;
  /* Stretch children to match the container's width */
  justify-content: flex-start;
  position: relative;
  display: flex;
  /* Align children in a row */
  flex-direction: column;
  justify-content: space-between;
  /* Distribute space between children */
  gap: 30px;
  border-radius: 10px;
  background: var(--white-base);

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 18px */
}

/* Style for the bar chart container */
.left-circle-chart {
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.right-bar-chart {
  flex: 1 1;
  /* Allow to grow to available space */
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--border);
}

.usercards-container {
  position: relative;
}

.usercards-scrollable{
  display: flex;
  flex-wrap: nowrap; /* Prevents the items from wrapping to the next line */
  overflow-x: auto; /* Enables horizontal scrolling */
  gap: 10px; /* Adds space between the flex items */
}

.all-user-listed-text{
  margin: 10px 0px;

  /* TEXT FONT */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
  

.gruppenauswertung-selector-container {
  position: absolute;
  top: 5%;
  right: 2%;
  z-index: 1; /* Ensure it's on top of other elements */
  width: fit-content;
  background-color: var(--gray-20);
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  padding: 5px 10px;

  /* TEXT FONT */
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
}

.gruppenauswertung-selector-item {
  background-color: var(--white-base); /* Background color for options */
  color: var(--gray-40);
}`, "",{"version":3,"sources":["webpack://./src/pages/BewertungGruppenAuswertung.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;;EAEvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;;AAEA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB;EACpB,oDAAoD;EACpD,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;EAC9B,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,6BAA6B;;EAE7B,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB,EAAE,sDAAsD;EACzE,gBAAgB,EAAE,iCAAiC;EACnD,SAAS,EAAE,sCAAsC;AACnD;;AAEA;EACE,gBAAgB;;EAEhB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU,EAAE,yCAAyC;EACrD,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,iBAAiB;;EAEjB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,mCAAmC,EAAE,iCAAiC;EACtE,qBAAqB;AACvB","sourcesContent":[".bewertung-auswertung-screen {\r\n  position: relative;\r\n  /*TEXT FONT*/\r\n  font-family: Inter;\r\n  font-style: normal;\r\n}\r\n\r\n/* SIDE SELECTOR START*/\r\n\r\n.selector-container {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: row;\r\n  top: 35px;\r\n  height: fit-content;\r\n  margin-right: 42px;\r\n  margin-left: 42px;\r\n  border-radius: 10px;\r\n  background: var(--searchbar-background);\r\n\r\n  /*Text Font*/\r\n  text-align: center;\r\n  /* Inter / 24 sp • H5 */\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.selector-item-selected {\r\n  display: flex;\r\n  align-items: center;\r\n  /* Center vertically */\r\n  justify-content: center;\r\n  /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  background: var(--white-base);\r\n  width: 100%;\r\n  text-align: center;\r\n  /* Center text within the flex container */\r\n}\r\n\r\n.selector-item-not-selected {\r\n  display: flex;\r\n  align-items: center;\r\n  /* Center vertically */\r\n  justify-content: center;\r\n  /* Center horizontally */\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  margin: 5px;\r\n  width: 100%;\r\n  text-align: center;\r\n  /* Center text within the flex container */\r\n}\r\n\r\n.selector-divider {\r\n  width: 1.48px;\r\n  height: 50.8px;\r\n  background-color: var(--gray-20);\r\n  margin: 10px;\r\n}\r\n\r\n/* SIDE SELECTOR END */\r\n\r\n/* MAIN CONTENT START*/\r\n.ga-singleContent-container {\r\n  position: relative;\r\n  margin-top: 80px;\r\n  margin-left: var(--content-space);\r\n  margin-right: var(--content-space);\r\n  /* Add vertical gap between children */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n}\r\n\r\n.ga-radar-parent-container{\r\n  max-height: 1000px;\r\n}\r\n\r\n/* MAIN CONTENT END*/\r\n\r\n.singleContent-container-selector {\r\n  position: relative;\r\n  max-height: 1000px;\r\n  margin-right: 0px;\r\n  margin-left: auto;\r\n  width: fit-content;\r\n}\r\n\r\n\r\n/* Style for the bar chart container */\r\n.singleContent-row-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Stack the children vertically */\r\n  align-items: stretch;\r\n  /* Stretch children to match the container's width */\r\n  justify-content: flex-start;\r\n  position: relative;\r\n  display: flex;\r\n  /* Align children in a row */\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  /* Distribute space between children */\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  background: var(--white-base);\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n  /* 18px */\r\n}\r\n\r\n.singleContent-column-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* Stack the children vertically */\r\n  align-items: stretch;\r\n  /* Stretch children to match the container's width */\r\n  justify-content: flex-start;\r\n  position: relative;\r\n  display: flex;\r\n  /* Align children in a row */\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  /* Distribute space between children */\r\n  gap: 30px;\r\n  border-radius: 10px;\r\n  background: var(--white-base);\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n  /* 18px */\r\n}\r\n\r\n/* Style for the bar chart container */\r\n.left-circle-chart {\r\n  width: fit-content;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n}\r\n\r\n.right-bar-chart {\r\n  flex: 1;\r\n  /* Allow to grow to available space */\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.usercards-container {\r\n  position: relative;\r\n}\r\n\r\n.usercards-scrollable{\r\n  display: flex;\r\n  flex-wrap: nowrap; /* Prevents the items from wrapping to the next line */\r\n  overflow-x: auto; /* Enables horizontal scrolling */\r\n  gap: 10px; /* Adds space between the flex items */\r\n}\r\n\r\n.all-user-listed-text{\r\n  margin: 10px 0px;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n}\r\n  \r\n\r\n.gruppenauswertung-selector-container {\r\n  position: absolute;\r\n  top: 5%;\r\n  right: 2%;\r\n  z-index: 1; /* Ensure it's on top of other elements */\r\n  width: fit-content;\r\n  background-color: var(--gray-20);\r\n  border-radius: 8px;\r\n  border: none;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n  padding: 5px 10px;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Poppins;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 18px */\r\n}\r\n\r\n.gruppenauswertung-selector-item {\r\n  background-color: var(--white-base); /* Background color for options */\r\n  color: var(--gray-40);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
